import { InputBaseComponentProps } from "@mui/material";
import { selectOption } from "../services/models/Context";

export const memoTypes = [
  { label: "Credit", value: "CREDIT" },
  { label: "Cash", value: "CASH" },
];

export const billStatus = [
  { label: "Pending", value: "PENDING" },
  { label: "Overdue", value: "OVERDUE" },
  { label: "Partial Paid", value: "PARTIAL_PAID" },
  { label: "Paid", value: "PAID" },
];

// DUE ON TYPE -- VALUE IS IN DAY(s)
export const dueOnTypes = [
  { label: "Due on Receipt", value: "1" },
  { label: "In 7 Days", value: "7" },
  { label: "In 15 Days", value: "15" },
  { label: "In 30 Days", value: "30" },
  { label: "In 45 Days", value: "45" },
  { label: "In 60 Days", value: "60" },
  { label: "In 90 Days", value: "90" },
  { label: "Custom Date", value: "CUSTOM_DATE" },
];

// UNDER MODULES
export const underModules = [
  { label: "OPD", value: "OPD" },
  // { label: "IPD", value: "IPD" }, -- TEMP HIDE
  { label: "OTHER", value: "OTHER" },
];

// TAX TYPES
export const taxTypes = [
  { label: "Tax Extra", value: "TEX" },
  { label: "Tax Included", value: "TIN" },
  { label: "Tax Not Applicable", value: "TNA" },
  { label: "Tax Exemption", value: "TEXM" },
];

// DATERANGE OPTIONS
export const dateDropDownOptions = [
  { label: "Today", value: 0, days: 0, code: "TODAY" },
  { label: "Yesterday", value: 1, days: 1, code: "YESTERDAY" },
  { label: "Last 15 days", value: 2, days: 15, code: "LAST_15_DAYS" },
  { label: "Last 30 days", value: 3, days: 30, code: "LAST_30_DAYS" },
  { label: "Last 45 days", value: 4, days: 45, code: "LAST_45_DAYS" },
  { label: "Last 90 days", value: 5, days: 90, code: "LAST_90_DAYS" },
  {
    label: "Current financial year",
    value: 6,
    days: 365,
    code: "CURRENT_FINANCIAL_YEAR",
  },
];

// PACKAGE TYPE
export const unitsPerVolumeForPackage = [
  { label: "ml", value: "ML" },
  { label: "Unit", value: "UNIT" },
];

export const draggableItemTypes = {
  CARD: "card",
};

export const dateRangePikerOptions = [
  { label: "Today", value: 0 },
  { label: "Yesterday", value: 1 },
  { label: "Last 15 days", value: 2 },
  { label: "Last 30 days", value: 3 },
  { label: "Last 90 days", value: 4 },
  { label: "Current financial year", value: 5 },
  { label: "All", value: 6 },
  { label: "Custom...", value: 7 },
];

export const mediaTypeMap: Record<string, selectOption> = {
  sms: { label: "sms", value: "SMS" },
  email: { label: "email", value: "EMAIL" },
  whatsapp: { label: "whatsapp", value: "WHATSAPP" },
  push: { label: "push", value: "PUSH" },
};

export const notificationTemplateForMap: Record<string, selectOption> = {
  vaccination: { label: "vaccination", value: "VACCINATION" },
  follow_up: { label: "follow-up", value: "FOLLOW_UP" },
  patient_opd: {
    label: "OPD Communication with patients",
    value: "PATIENT_OPD",
  },
  // referred_to: { label: "reffered to", value: "REFFERED_TO" },
  referral_doctor_opd: {
    label: "referral doctor opd communication",
    value: "REFERRAL_DOCTOR_OPD",
  },
  "out-of-office": { label: "out-of-office", value: "OUT_OF_OFFICE" },
  "outreached-opd": { label: "outreached-opd", value: "OUTREACHED_OPD" },
  referral_doctor_list: {
    label: "referral doctor",
    value: "REFERRAL_DOCTOR_LIST",
  },
  patient_scheduled_opd: { label: "Patient Scheduled OPD", value: "PATIENT_SCHEDULED_OPD" },
  patient_waiting_opd: { label: "Patient Waiting OPD", value: "PATIENT_WAITING_OPD" },
  out_reach: { label: "Out Reach", value: "OUT_REACH" },
};

export const inputPropsForNumberField: any = {
  className: "no-spinner",
  inputMode: "numeric",
  pattern: "[0-9]*[.]?[0-9]*",
  step: "1",
  min: 0,
  onKeyPress: (event: any) => {
    // if (!/[0-9.]/.test(event.key)) {
    //   event.preventDefault();
    // }
    const key = event.key;
    const value = event.target.value;

    // Allow digits, a single decimal point (if not already in the value)
    if (
      (!/[0-9]/.test(key) && key !== "." && key !== ",") ||
      ((key === "." || key === ",") && value.includes("."))
    ) {
      event.preventDefault();
    }
  },
};

export const createInputPropsForNumberField = (
  maxIntegers: number,
  maxDecimals: number,
  allowDecimal: boolean,
): InputBaseComponentProps => ({
  className: "no-spinner",
  inputMode: allowDecimal ? "decimal" : "numeric", // Switch based on whether decimals are allowed
  pattern: allowDecimal
    ? `[0-9]{0,${maxIntegers}}[.,]?[0-9]{0,${maxDecimals}}`
    : `[0-9]{0,${maxIntegers}}`,
  step:
    allowDecimal && maxDecimals > 0
      ? `0.${"1".padStart(maxDecimals, "0")}`
      : "1",
  min: 0,
  onKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => {
    const key = event.key;
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const decimalSeparator = ".";

    // Check if any text is selected
    const isTextSelected =
      input.selectionStart !== null &&
      input.selectionEnd !== null &&
      input.selectionStart !== input.selectionEnd;

    // Allow overwriting when any text is selected
    if (isTextSelected) {
      return;
    }

    // Allow only numeric values if decimals are not allowed
    if (!allowDecimal) {
      if (!/[0-9]/.test(key)) {
        event.preventDefault();
      }
      if (value.length >= maxIntegers) {
        event.preventDefault();
      }
      return;
    }

    // If decimals are allowed
    if (
      (!/[0-9]/.test(key) && key !== decimalSeparator) ||
      (key === decimalSeparator && value.includes(decimalSeparator))
    ) {
      event.preventDefault();
      return;
    }

    // Restrict the number of integers and decimals
    if (value.includes(decimalSeparator)) {
      const [integerPart, decimalPart] = value.split(decimalSeparator);

      // Restrict the number of decimal places
      if (
        decimalPart &&
        decimalPart.length >= maxDecimals &&
        key !== "Backspace"
      ) {
        event.preventDefault();
      }
    } else {
      // Restrict the number of integer digits
      if (value.length >= maxIntegers && key !== decimalSeparator) {
        event.preventDefault();
      }
    }
  },
  onInput: (event: React.FormEvent<HTMLInputElement>) => {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const decimalSeparator = ".";

    if (!allowDecimal) {
      // If decimals are not allowed, ensure only integer part is valid
      if (value.length > maxIntegers) {
        input.value = value.slice(0, maxIntegers);
      }
      return;
    }

    // Enforce the number of integers and decimals
    if (value.includes(decimalSeparator)) {
      const [integerPart, decimalPart] = value.split(decimalSeparator);

      if (integerPart.length > maxIntegers) {
        input.value =
          integerPart.slice(0, maxIntegers) +
          decimalSeparator +
          (decimalPart || "");
      }

      if (decimalPart && decimalPart.length > maxDecimals) {
        input.value =
          integerPart + decimalSeparator + decimalPart.slice(0, maxDecimals);
      }
    } else if (value.length > maxIntegers) {
      input.value = value.slice(0, maxIntegers);
    }
  },
});

export const createOnWheelHandler =
  (step: number, min: number, maxDecimals: number = 0) =>
  (event: React.WheelEvent<HTMLInputElement>) => {
    event.preventDefault(); // Prevent default scroll behavior
    event.stopPropagation(); // Stop propagation to parent scrollable containers

    const input = event.currentTarget;
    const currentValue = parseFloat(input.value) || 0; // Handle empty or invalid values

    // Calculate the new value based on scroll direction
    const newValue =
      event.deltaY < 0 ? currentValue + step : currentValue - step;

    // Apply minimum value restriction
    const clampedValue = Math.max(
      min,
      parseFloat(newValue.toFixed(maxDecimals)),
    ); // Ensure the value doesn't go below the minimum

    input.value = clampedValue.toString(); // Update the input value
  };

export const createInputPropsWithSeparator = (
  maxNumberBefore: number,
  maxNumberAfter: number,
  separator: string,
  maxValueBefore: number,
  maxValueAfter: number = Number.MAX_SAFE_INTEGER,
): InputBaseComponentProps => ({
  inputMode: "numeric", // Ensures numeric input
  onKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => {
    const key = event.key;
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Check if any text is selected
    const isTextSelected =
      input.selectionStart !== null &&
      input.selectionEnd !== null &&
      input.selectionStart !== input.selectionEnd;

    // Allow overwriting when any text is selected
    if (isTextSelected) {
      return;
    }

    // Allow only numeric characters and the separator
    if (!/[0-9]/.test(key) && key !== separator) {
      event.preventDefault();
      return;
    }

    // Prevent multiple separators
    if (key === separator && value.includes(separator)) {
      event.preventDefault();
      return;
    }

    // Split the input value into parts
    const [beforePart, afterPart] = value.split(separator);

    // Restrict the number of digits before the separator
    if (
      beforePart?.length >= maxNumberBefore &&
      key !== separator &&
      !value.includes(separator) &&
      afterPart !== undefined
    ) {
      event.preventDefault();
      return;
    }

    // Restrict the number of digits after the separator
    if (
      value.includes(separator) &&
      afterPart?.length >= maxNumberAfter &&
      beforePart?.length >= maxNumberBefore
    ) {
      event.preventDefault();
      return;
    }
  },
  onInput: (event: React.FormEvent<HTMLInputElement>) => {
    let maxBefore: number = maxNumberBefore;
    const input = event.target as HTMLInputElement;
    const invalidCharsRegex = new RegExp(`[^0-9${separator}]`, "g");
    let value = input.value.replace(invalidCharsRegex, ""); // Remove invalid characters

    // Check if the separator is present
    const hasSeparator = value.includes(separator);

    // Split the value into parts
    let [beforePart = "", afterPart = ""] = value.split(separator);

    // // Handle overflow from `beforePart` to `afterPart` if necessary
    if (
      (beforePart.length > maxBefore && maxNumberAfter > 0) ||
      (parseFloat(beforePart) ?? 0) > maxValueBefore
    ) {
      let overflow = beforePart.slice(maxBefore);
      beforePart = beforePart.slice(0, maxBefore);

      if ((parseFloat(beforePart) ?? 0) > maxValueBefore) {
        overflow = beforePart.slice(maxBefore - 1);
        beforePart = beforePart.slice(0, maxBefore - 1);
      }

      afterPart = overflow + afterPart;
    }

    // Enforce length restrictions
    beforePart = beforePart?.slice(0, maxBefore);
    afterPart = afterPart?.slice(0, maxNumberAfter);

    // Enforce max value restrictions
    if ((parseFloat(afterPart) ?? 0) > maxValueAfter) {
      afterPart = maxValueAfter.toString();
    }

    // Update the input value
    input.value =
      afterPart.length > 0
        ? `${beforePart}${separator}${afterPart}`
        : hasSeparator
          ? `${beforePart}${separator}`
          : beforePart;
  },
});

export const isEditorContentEmpty = (content: any) => {
  return (
    !content || content.trim() === "<p><br></p>" || content.trim() === "<p></p>"
  );
};

export const genderOptions: selectOption[] = [
  { value: "MALE", label: "Male" },
  { value: "FEMALE", label: "Female" },
  { value: "OTHER", label: "Other" },
];
